/**
 * Prod observability when Census/BLS API keys are missing from Cloud Run secrets.
 */
import { logAuditEvent } from '../../lib/telemetry/auditTelemetry';

const warned = new Set<'census' | 'bls'>();

export function warnUnkeyedSentimentFetcher(fetcher: 'census' | 'bls'): void {
  if (process.env.NODE_ENV !== 'production') return;
  if (warned.has(fetcher)) return;
  warned.add(fetcher);

  const envName = fetcher === 'census' ? 'CENSUS_API_KEY' : 'BLS_API_KEY';
  console.warn(
    `[sentiment] ${envName} missing in prod — rate-limited unkeyed access`,
  );

  if (typeof window !== 'undefined') {
    logAuditEvent({
      type: 'sentiment-fetcher-unkeyed',
      payload: { fetcher },
    });
  }
}

/** Test hook — reset once-per-process dedupe. */
export function __resetUnkeyedSentimentWarningsForTests(): void {
  warned.clear();
}
